import { useEffect } from "react";
import "../styles/_contextMenu.scss";

const ContextMenu = ({ visible, x, y, items, onClose }) => {
  useEffect(() => {
    if (!visible) return;
    const handleClickOutside = (event) => {
      if (!event.target.closest(".context-menu")) {
        onClose && onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [visible, onClose]);

  if (!visible) return null;

  return (
    <ul
      className="context-menu"
      style={{
        top: y,
        left: x-110,
      }}
    >
      {items.map((item, idx) => (
        <li
          key={idx}
          style={{ padding: "8px 16px", cursor: "pointer" }}
          onClick={item.onClick}
        >
          {item.label}
        </li>
      ))}
    </ul>
  );
};

export default ContextMenu;
